module.exports = __webpack_public_path__ + "static/media/client-a.77dfdce9.png";